import React from 'react';

export const ChevronDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    style={{ width: '14px', height: '14px' }}
  >
    <path
      fill="#fff"
      fillRule="nonzero"
      id="a"
      d="M8 11.92125l-5.73230769-5.425 1.31076923-1.2425L8 9.45375l4.4215385-4.2 1.3107692 1.2425z"
    />
  </svg>
);

export const ChevronUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    style={{ width: '14px', height: '14px' }}
  >
    <path
      fill="#fff"
      fillRule="nonzero"
      id="a"
      d="M8 5.25375l5.7323077 5.425-1.3107692 1.2425L8 7.72125l-4.42153846 4.2-1.31076923-1.2425z"
    />
  </svg>
);

export const ChevronRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path
      fill="#0077C8"
      fillRule="evenodd"
      d="M8.583 18.514L6.875 16.712 12.65 10.632 6.875 4.552 8.583 2.75 16.043 10.632z"
    />
  </svg>
);

export const ChevronDoubleRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path
      fill="#0077C8"
      fillRule="evenodd"
      d="M11.837 4.462l-1.674 1.653 5.657 5.572-5.657 5.573 1.674 1.653 7.307-7.226-7.307-7.225zm-7.072 0L3.092 6.115l5.657 5.572-5.657 5.573 1.673 1.653 7.308-7.226-7.308-7.225z"
    />
  </svg>
);

export const ChevronLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path
      fill="#0077C8"
      fillRule="evenodd"
      d="M12.959 18.885L5.5 11.003 12.959 3.121 14.668 4.924 8.893 11.003 14.668 17.083 12.959 18.885z"
    />
  </svg>
);

export const ChevronDoubleLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path
      fill="#0077C8"
      fillRule="evenodd"
      d="M11.981 5.167l-1.72-1.73L2.75 11l7.511 7.563 1.72-1.73L6.166 11l5.815-5.833zm7.269 0l-1.72-1.73L10.019 11l7.51 7.563 1.721-1.73L13.435 11l5.815-5.833z"
    />
  </svg>
);

export const Flag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    style={{ width: '14px', height: '14px' }}
  >
    <path
      fill="#000"
      fillRule="nonzero"
      d="M5 3.5221875v2.199375c-.87375.1203125-1.7665625.4196875-2.25.7146875V4.2696875c.536875-.3275 1.353125-.660625 2.25-.7475zm4.5.8925C8.68996875 4.28 7.97353125 4.01128125 7.25 3.800625V5.8825c.7450625.1959375 1.45240625.47378125 2.25.64125V4.4146875zM5 5.7215625v2.158125c.95409375-.09425 1.605125-.03921875 2.25.0965625V5.8825c-.89125-.234125-1.52240625-.2606875-2.25-.1609375zm2.25 4.36375c.81075.1348125 1.52678125.4035625 2.25.6140625V8.6175c-.73928125-.194125-1.45334375-.4741875-2.25-.64125v2.1090625zm-4.5.4384375c.6784375-.2171875 1.47625-.3715625 2.25-.45375V7.8796875c-.75875.074375-1.5003125.2378125-2.25.4775V10.52375zM14 3.7525c-.6634375.2540625-1.45875.494375-2.25.6309375V6.589375c.7825-.12625 1.5178125-.39 2.25-.6703125V3.7525zm0 6.4778125V8.06375c-.4834375.295-1.37625.594375-2.25.7146875v2.199375c.896875-.086875 1.713125-.42 2.25-.7475zM9.5 6.52375V8.6175c.89125.234125 1.5224062.2606875 2.25.1609375V6.589375c-.74475.1196875-1.453875.10196875-2.25-.065625zm4.40925-4.90440625C14.898 1.19278125 16 1.9211875 16 2.99803125v7.49743755c0 .506125-.2548125.9783125-.6785313 1.255125C14.4909688 12.2932188 13.1318125 13 11.3043437 13c-2.14399995 0-3.5244062-1-5.0597812-1-1.76771875 0-2.81115625.3525-3.9945625.8924063V15.5c0 .2761563-.22384375.5-.5.5h-.5c-.27615625 0-.5-.2238437-.5-.5V2.7988125C.30178125 2.5394375 0 2.055125 0 1.5 0 .63846875.7263125-.0534375 1.60003125.00325c.7176875.0465625 1.30828125.60846875 1.39 1.323.02534696.21820324.00249697.43931055-.0669375.64771875C3.6236875 1.7025625 4.4675 1.5 5.44565625 1.5c2.144 0 3.52440625 1 5.05978125 1 1.1083437 0 2.2818437-.39659375 3.4038125-.88065625zM14.5 3c-.9845938.4573125-2.6423438 1-3.9945625 1-1.87221875 0-3.1865-1-5.05978125-1C4.15075 3 2.93075 3.518375 2.25 4v7.25c.98271875-.4561562 2.63953125-.75 3.9945625-.75 1.87221875 0 3.1865 1 5.0597813 1 1.2949062 0 2.5149375-.518375 3.1956562-1V3z"
    />
  </svg>
);

export const Trash = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 16"
    style={{ width: '14px', height: '14px' }}
  >
    <path
      fill="#000"
      fillRule="nonzero"
      d="M6 5.875v6.75c0 .2070938-.16790625.375-.375.375h-.75c-.20709375 0-.375-.1679062-.375-.375v-6.75c0-.20709375.16790625-.375.375-.375h.75c.20709375 0 .375.16790625.375.375zM9.125 5.5h-.75c-.20709375 0-.375.16790625-.375.375v6.75c0 .2070938.16790625.375.375.375h.75c.20709375 0 .375-.1679062.375-.375v-6.75c0-.20709375-.16790625-.375-.375-.375zm4.125-3c.4142187 0 .75.33578125.75.75v.375c0 .20709375-.1679062.375-.375.375H13v10.5c0 .8284375-.6715625 1.5-1.5 1.5h-9c-.8284375 0-1.5-.6715625-1.5-1.5V4H.375C.16790625 4 0 3.83209375 0 3.625V3.25c0-.41421875.33578125-.75.75-.75h2.32534375L4.13840625.72825c.27108839-.45180892.75935322-.72825507 1.28625-.72825H8.575375c.52689678-.00000507 1.01516161.27644108 1.28625.72825L10.9246562 2.5H13.25zm-8.42534375 0H9.175375L8.63 1.59103125C8.59611395 1.53455514 8.53508085 1.49999937 8.46921875 1.5h-2.938375c-.0658621-6.3e-7-.1268952.03455514-.16078125.09103125L4.82465625 2.5zM11.5 4h-9v10.3125c0 .1035534.08394661.1875.1875.1875h8.625c.1035534 0 .1875-.0839466.1875-.1875V4z"
    />
  </svg>
);

export const Pause = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 12"
    style={{ width: '14px', height: '14px' }}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#000"
        fillRule="nonzero"
        d="M.5 11.25h3V.75h-3v10.5zm6-10.5v10.5h3V.75h-3z"
      />
      <path d="M-4-3h18v18H-4z" />
    </g>
  </svg>
);

export const Play = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 12"
    style={{ width: '14px', height: '14px' }}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#000" d="M0 .75v10.5L8.25 6z" />
      <path d="M-6-3h18v18H-6z" />
    </g>
  </svg>
);

export const Save = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    style={{ width: '14px', height: '14px' }}
  >
    <path
      fill="#000"
      fillRule="nonzero"
      d="M15.4978929 3.49789286L12.5021071.50210714C12.180618.18061566 11.7445845.00000238 11.2899286 0H1.71428571C.7675 0 0 .7675 0 1.71428571V14.2857143C0 15.2325.7675 16 1.71428571 16H14.2857143C15.2325 16 16 15.2325 16 14.2857143V4.71007143c-.0000024-.45465593-.1806157-.89068947-.5021071-1.21217857zM9.71428571 1.71428571v2.85714286H5.14285714V1.71428571h4.57142857zM14.0714286 14.2857143H1.92857143c-.11834673 0-.21428572-.095939-.21428572-.2142857V1.92857143c0-.11834673.09593899-.21428572.21428572-.21428572h1.5v3.71428572c0 .47339286.38375.85714286.85714286.85714286h6.28571431c.4733928 0 .8571428-.38375.8571428-.85714286V1.85292857l2.7943929 2.79439286c.0401848.04019161.0627568.094701.06275.15153571v9.27257146c0 .1183467-.095939.2142857-.2142857.2142857zM8 7.14285714c-1.73296429 0-3.14285714 1.40989286-3.14285714 3.14285716 0 1.7329643 1.40989285 3.1428571 3.14285714 3.1428571 1.73296429 0 3.1428571-1.4098928 3.1428571-3.1428571C11.1428571 8.55275 9.73296429 7.14285714 8 7.14285714zm0 4.57142856c-.78771429 0-1.42857143-.6408571-1.42857143-1.4285714C6.57142857 9.498 7.21228571 8.85714286 8 8.85714286S9.42857143 9.498 9.42857143 10.2857143 8.78771429 11.7142857 8 11.7142857z"
    />
  </svg>
);

export const Clock = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    style={{ width: '14px', height: '14px' }}
  >
    <g fill="#000" fillRule="nonzero">
      <path d="M8 0c4.418278 0 8 3.581722 8 8s-3.581722 8-8 8-8-3.581722-8-8c0-2.12173192.8428547-4.15656322 2.3431458-5.65685425C3.8434368.84285472 5.8782681 0 8 0zm0 14.4c3.5346224 0 6.4-2.8653776 6.4-6.4 0-3.5346224-2.8653776-6.4-6.4-6.4-3.5346224 0-6.4 2.8653776-6.4 6.4 0 1.69738553.6742838 3.3252506 1.8745166 4.5254834C4.6747494 13.7257162 6.30261447 14.4 8 14.4z" />
      <path d="M8 3.2h1.2v5.016c0 .54344819-.44055181.984-.984.984H4V8h4V3.2z" />
    </g>
  </svg>
);

export const ArrowEast = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    style={{ width: '14px', height: '14px' }}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-3-3h18v18H-3z" />
      <path
        fill="#000"
        d="M6 0L4.94 1.06l4.19 4.19H0v1.5h9.13l-4.19 4.19L6 12l6-6z"
      />
    </g>
  </svg>
);
